export default "__VITE_ASSET__B8vi1Bvv__"